export enum MixedLoyaltyItemType{
    Auction,
    Lotto,
    Marketplace,
    All
}